<LOSx-entity-notes-tab
  [entityId]="entityId"
  [entityNotes]="entityNotes"
  [callbackAdd]="addNote"
  [callbackEdit]="editNote"
  [callbackDelete]="deleteNote"
>
</LOSx-entity-notes-tab>
